import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["avatarPreview"]

  previewAvatar(event) {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.avatarPreviewTarget.innerHTML = `<img src="${e.target.result}" class="h-full w-full object-cover" alt="Avatar preview">`
      }
      reader.readAsDataURL(file)
    }
  }
}
